import { render, staticRenderFns } from "./GoodEdit.vue?vue&type=template&id=61f9e354&"
import script from "./GoodEdit.vue?vue&type=script&lang=js&"
export * from "./GoodEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports